import PostOrderForm from "../components/student/PostNewOrder";
import StudentDashboardLayout from "../components/StudentDashboardLayout";

function PostNewOrderPage(){
    return(
    <StudentDashboardLayout>
        <PostOrderForm/>
    </StudentDashboardLayout>)
}
export default PostNewOrderPage